import type { LogRecord } from './interfaces/log-record.interface.js';
import type { LoggerProvider } from './logger.provider.js';

export class LoggerService<T> {
  constructor(private readonly loggerProvider: LoggerProvider<T>) {}

  log(logRecord: LogRecord) {
    this.loggerProvider.getLogger(logRecord.logger).log(logRecord);
  }
}
